// Auth0's users-by-email lookup is case-sensitive and trips on stray spaces,
// while Auth0 stores emails lowercased — so normalize before sending, or a
// "Deja@…" input 404s where "deja@…" works.
export const normalizeEmail = (v) => (v || "").trim().toLowerCase();

// Compare two addresses the way the API will see them, not the way they were
// typed. Used to stop a "change email" request whose old and new values only
// differ by case or surrounding whitespace.
export const sameEmail = (a, b) => normalizeEmail(a) === normalizeEmail(b);

// Shared Vuetify field-rule sets. Each rule returns true when valid, or an
// error string. Used via :rules on <v-text-field> and checked up-front with
// form.validate() before submitting.
export const emailRules = [
  (v) => !!v || "E-mail is required",
  (v) => /.+@.+/.test(v) || "E-mail must be valid",
];

export const membershipNumberRules = [
  (v) => !!v || "Membership number is required",
  (v) => /^\d+$/.test(v) || "Membership number can only contain numbers",
  (v) =>
    (v && String(v).length <= 9) ||
    "Membership number must be 9 digits or fewer",
];
